import React from 'react';
import {Container, Carousel, Button } from 'react-bootstrap';

import productList from './../../product-list.json';
import iconAmazon from './../Common/icon-amazon.svg';


const Banner = ()=>{

	const bannerItems = [];

	for (const key in productList){
		const product = productList[key]
		
		// skip if not featured
		if(!product.featured)
			continue;

		const id = product.sku;
		bannerItems.push(
			<Carousel.Item id={id} key={id} className="banner_item">
			    <Carousel.Caption className="banner_item-caption">
			      <h3>{product.title}</h3>
			      <p>{product.description}</p>
			      <Button 	variant="primary" 
						    className="checkout-button"
			      			onClick={()=>window.open(product.link, '_blank', 'noopener')} 
						>
					<img 	src={iconAmazon} 
							alt="Amazon logo" 
							className="button-icon"
						/>
					Buy on Amazon
				</Button>
			    </Carousel.Caption>
			    <img
			      className="banner_item-img"
			      src={require(`./banner-${product.sku}.jpg`)}
			      alt={product.title}
			    />
			</Carousel.Item>
		);
	}

	return(
		<Container fluid className="p-0 banner-wrapper">
			<Carousel 	className="banner" 
						fade={true} 
						slide={false}
				>
			  	{bannerItems}		  
			</Carousel>
		</Container>
	)
}

export default Banner;